import { HttpTypes } from '@/types';
import { BaseLocation } from '@/types/http/location/common';

import { AxiosInstance } from 'axios';

class Locations {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(query: HttpTypes.FindParams): Promise<HttpTypes.IResponse<BaseLocation[]>> {
    const result = await this.client.get(`/sites/location`, {
      params: query,
    });
    return result.data;
  }

  async detail(id: string): Promise<HttpTypes.IResponse<HttpTypes.AdminLocation>> {
    const response = await this.client.get(`/sites/location/${id}`);
    return response.data;
  }
}

export default Locations;
